import PUT from './api/put'

export default {
  PUT
}
